import { render, staticRenderFns } from "./dataitemC.vue?vue&type=template&id=e46dfb44&scoped=true&"
import script from "./dataitemC.vue?vue&type=script&lang=js&"
export * from "./dataitemC.vue?vue&type=script&lang=js&"
import style0 from "./dataitemC.vue?vue&type=style&index=0&id=e46dfb44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46dfb44",
  null
  
)

export default component.exports